import { Component, OnInit } from '@angular/core';
import { UserService } from '../../services/user.service';
import { AuthenticatedUser } from 'src/app/users/models/user.model';
import { JwtService } from '../../services/jwt.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-authenticated-layout',
  templateUrl: './authenticated-layout.component.html',
  styleUrls: ['./authenticated-layout.component.scss']
})
export class AuthenticatedLayoutComponent implements OnInit {

  public isTogglerActive: boolean = false;
  public user?: AuthenticatedUser;
  public isAdmin: boolean;
  public isUser: boolean;
  public isRegionalManager: boolean;
  public isReporter: boolean;

  constructor(private _userService: UserService, private _jwtService: JwtService,
    private _router: Router) { 
    this.user = _userService.currentUser();
    this.isAdmin = this._userService.isAdmin;
    this.isRegionalManager = this._userService.isRegionalManager;    
    this.isReporter = this._userService.isReporter;
    this.isUser = this._userService.isUser;
  }

  ngOnInit(): void {
  }

  public toggleIsActive() {
    this.isTogglerActive = !this.isTogglerActive;
  }

  public getRoles(): string {
    if(this.user && this.user.roles) {
      return this.user?.roles[0]?.name ? this.user?.roles[0]?.name : '';
    }
    return '';
  }
  public signOut(){
    this._jwtService.removeToken();
    this._router.navigate(['/signin']);
  }
}
